<script>
  import Header from "lib/components/Header.svelte";
  import { Loading } from "carbon-components-svelte";

  export let header = [];
  export let rows = [];
  export let loading = true;
  export let to = "";
  export let from = "";
  export let disableFinalField = false;
  export let boldFirstHeader = true;
  export let marginBottom = "0vh";
  export let rowHeaderPadding = "0.5rem";

  let highlightFrom = -1;
  let highlightTo = -1;

  function setHighlight(i, j) {
    if (i === rows.length - 1 || j === header.length - 1) return;
    if (disableFinalField && !(j < rows[0].length - 1 && i < header.length - 2))
      return;
    highlightFrom = j;
    highlightTo = i;
  }
</script>

<Header section="KPI" breadcrumb="Matrix"></Header>

    {#if loading}
      <div class="loading_wrapper">
        <Loading withOverlay={false} />
      </div>
    {:else}
      <div
        class="table-container"
        style="--margin-bottom: {marginBottom}; --row-header-padding: {rowHeaderPadding}"
      >
        <table style="margin-top: 20px; width: 100%;" class="grid-table">
          <thead>
            <tr>
              {#each header as head, i}
                <th
                  class="header {i === 0 && boldFirstHeader ? 'bold' : ''}"
                  class:highlight={highlightFrom === i}
                  class:notHover={i === header.length - 1 && disableFinalField}
                  on:mousedown={() => {
                    if (i === header.length - 1 && disableFinalField) return;
                    to = head;
                  }}>{head}</th
                >
              {/each}
            </tr>
          </thead>
          <tbody>
            {#each rows as row, i}
              <tr>
                {#each row as cell, j}
                  {#if j === 0}
                    <th
                      class="app_name left"
                      class:highlight={highlightTo === i}
                      class:notHover={i === rows.length - 1 &&
                        disableFinalField}
                      on:mousedown={() => {
                        if (i === rows.length - 1 && disableFinalField) return;
                        from = cell;
                      }}
                    >
                      {cell}
                    </th>
                  {:else}
                    <td
                      class="value {cell === '' || cell === 0
                        ? 'empty-cell'
                        : i === rows.length - 1 || j === header.length - 1
                          ? 'cell-total'
                          : 'cell-content'}"
                      on:mouseenter={() => {
                        if (i !== rows.length - 1 && j !== header.length - 1) {
                          setHighlight(i, j);
                        }
                      }}
                      on:mouseleave={() => {
                        setHighlight(-1, -1);
                      }}
                      on:mousedown={() => {
                        if (
                          cell === "" ||
                          cell === 0 ||
                          i === rows.length - 1 ||
                          j === header.length - 1
                        )
                          return;
                        from = row[0];
                        to = header[j];
                      }}
                    >
                      <div class="cell">
                        {cell}
                      </div>
                    </td>
                  {/if}
                {/each}
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    {/if}

<style>
  .table-container {
    height: calc(85vh - var(--margin-bottom));
    overflow-y: visible;
    top: 0;
    max-width: 100%;
    overflow-x: auto;
  }

  .grid-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 5px;
    font-family: Arial, sans-serif;
    color: #ffffff;
    background-color: #1c1c20 !important;
    border: 8px solid #1c1c20 !important;
    border-radius: 0.5rem;
  }

  .grid-table th,
  .grid-table thead,
  .grid-table tbody {
    text-align: center;
  }

  .grid-table .header.bold {
    color: white;
    font-weight: bold;
    height: 100%;
  }

  .grid-table th.header {
    position: sticky !important;
    top: 0;
    z-index: 100;
    padding: 0.5rem 0.3rem;
    font: inherit;
    font-weight: normal;
  }

  .grid-table th.header.bold {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 102;
    padding: 0.5rem 0.3rem;
  }

  .grid-table th.app_name,
  .grid-table td:first-child {
    position: sticky;
    left: 0;
    z-index: 101;
    background-color: #2f4858;
  }

  .grid-table th.left {
    background-color: #2f4858;
    text-align: center;
    vertical-align: middle;
    height: 100%;
    font-weight: normal;
    padding: var(--row-header-padding);
  }

  .header,
  .app_name,
  .notHover {
    background-color: #2f4858;
    font-weight: normal;
  }

  .grid-table td {
    background-color: #3e6373 !important;
    height: auto;
    vertical-align: middle;
  }

  .grid-table td .value {
    background-color: #2f4858 !important;
    text-align: center;
    height: 100%;
    font-weight: normal;
    padding: 0.5rem;
    z-index: 105;
    justify-items: center;
  }

  .grid-table td .cell-content,
  .grid-table td .cell-total {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-color: #3e6373 !important;
    color: white;
  }

  .cell {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    height: 100%;
    width: 100%;
  }

  .grid-table td.value.cell-content:hover {
    background-color: #76bbea !important;
    cursor: pointer;
  }

  /* .grid-table .highlight {
    background-color: #76bfea !important;
    color: #282828;
    font-weight: normal !important;
  } */

  .loading_wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
    width: 100%;
  }

  .grid-table td.empty-cell {
    background-color: #2f4858 !important;
  }
  th.highlight,
  th:hover {
    background-color: #76bfea !important;
    color: #282828;
    font-weight: normal !important;
    cursor: pointer;
  }

  .notHover:hover {
    background-color: #2f4858 !important;
    color: white !important;
    cursor: default !important;
  }
</style>
